// extracted by css-extract-rspack-plugin
export default {"root":"root-du8owt","title":"title-yFJxHB","card":"card-PoBgbH","img":"img-B6_OLr","lead":"lead-Y3Yc8A","buttons":"buttons-CBeGCn","button":"button-E4Xzp7","icon":"icon-L2wuc0"};